import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Collapse, Form, Row } from 'react-bootstrap';
import DropDown from '../../../../../../DropDown/DropDown';
import ProjectAPIs from '../../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs';
import { useNavigate } from 'react-router-dom';
import { MdAddCircle } from 'react-icons/md';
import { useToast } from '../../../../../../../Contexts/ToastContext';
import ApiResponseHandler from '../../../../../../../MasonyFixingsAPIs/ApiResponseHandler';
import UserAccountAPIs from '../../../../../../../MasonyFixingsAPIs/UserAccountAPIs/UserAccountAPIs';


export default function AddAnchorTraining({projectID, handleAddNew}){

    const { addToast } = useToast();
    const navigate = useNavigate();
    const [sending, setSending] = useState(false);
    const [addAnchorTraining, setAddAnchorTraining] = useState(false);
    const [userID, setUserID] = useState('');
    const [date, setDate] = useState('');
    const [note, setNote] = useState('');
    const [loggedInUser, setLoggedInUser] = useState();

    const handleSubmit = () => {
        // e.stopPropagation();
        // e.preventDefault();
        setSending(true);

        const postJSON = {
            user_id: userID,
            date: date,
            note: note
        }

        if(userID !== '' && date !== ''){
            ProjectAPIs.PostProjectAnchorTraining(projectID, postJSON)
            .then((response) => {
                if(response.status ===200){
                    handleAddNew(projectID);
                    setAddAnchorTraining(false)
                    setSending(false);
                    setUserID('');
                    setDate('');
                    setNote('');
                    addToast({ message: "Anchor Training recorded successfully!", variant: "success", autoHide: true });
                }
            })
            .catch((err) => {
                console.log(err)
                ApiResponseHandler(err.response, navigate);
            })
        }

        
    }

    const getUserDetails = () => {
        UserAccountAPIs.GetUserAccount()
        .then((response) => {
            if(response.status === 200){
                setLoggedInUser(response.data);
                setUserID(response.data.id);
            }
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    useEffect(() => {
        getUserDetails();
    }, []);

    return(
          
            <>
            <div className="project-header-actions">
                    <button
                        disabled={sending || !addAnchorTraining}
                        onClick={handleSubmit}
                        className="save-btn"
                        style={addAnchorTraining ? {display: 'block'} : {display: 'none'}}
                    >
                        {sending ? 'Saving...' : 'Save'}
                    </button>

                        <button
                            disabled={sending}
                            className="cancel-btn"
                            onClick={() => setAddAnchorTraining(!addAnchorTraining)}
                        >
                            {addAnchorTraining ? 'Cancel' : <><MdAddCircle /> Add New</>}
                        </button>
                    
                </div>
            {/* Add Induction Form */}
            <Collapse in={addAnchorTraining} >
                <Card className="mb-2">
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                            <DropDown.Users required className='m-1 editable-field' value={userID} onChange={(e) => setUserID(e.target.value)} />
                                
                            </Col>
                            <Col md={6}>
                                <Form.Control required className='m-1 editable-field' type='date' value={date} onChange={(e) => setDate(e.target.value)} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Control as={'textarea'} rows={3} className='m-1 editable-field' placeholder='Leave a note...' value={note} onChange={(e) => setNote(e.target.value)} />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Collapse>
            </>
    )

}